'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var EC = require('elliptic').ec;

var ec = new EC('secp256k1');

var Keystore =
/*#__PURE__*/
function () {
  function Keystore(storage) {
    _classCallCheck(this, Keystore);

    this._storage = storage;
  }

  _createClass(Keystore, [{
    key: "createKey",
    value: function createKey(id) {
      var key = ec.genKeyPair();
      var publicKey = key.getPublic('hex');
      var privateKey = key.getPrivate('hex');

      this._storage.setItem(id, JSON.stringify({
        publicKey: publicKey,
        privateKey: privateKey
      }));

      return key;
    }
  }, {
    key: "getKey",
    value: function getKey(id) {
      var key = JSON.parse(this._storage.getItem(id));
      if (!key) return;
      var k = ec.keyPair({
        pub: key.publicKey,
        priv: key.privateKey,
        privEnc: 'hex',
        pubEnc: 'hex'
      });
      return k;
    }
  }, {
    key: "generateKey",
    value: function generateKey() {
      return Promise.resolve(ec.genKeyPair());
    }
  }, {
    key: "exportPublicKey",
    value: function exportPublicKey(key) {
      return Promise.resolve(key.getPublic('hex'));
    }
  }, {
    key: "exportPrivateKey",
    value: function exportPrivateKey(key) {
      return Promise.resolve(key.getPrivate('hex'));
    }
  }, {
    key: "importPublicKey",
    value: function importPublicKey(key) {
      return Promise.resolve(ec.keyFromPublic(key, 'hex'));
    }
  }, {
    key: "importPrivateKey",
    value: function importPrivateKey(key) {
      return Promise.resolve(ec.keyFromPrivate(key, 'hex'));
    }
  }, {
    key: "sign",
    value: function sign(key, data) {
      var sig = ec.sign(data, key);
      return Promise.resolve(sig.toDER('hex'));
    }
  }, {
    key: "verify",
    value: function verify(signature, key, data) {
      var res = false;
      res = ec.verify(data, signature, key);
      return Promise.resolve(res);
    }
  }]);

  return Keystore;
}();

module.exports = function (LocalStorage, mkdir) {
  return {
    create: function create() {
      var directory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : './keystore';
      // If we're in Node.js, mkdir module is expected to passed
      // and we need to make sure the directory exists
      if (mkdir && mkdir.sync) mkdir.sync(directory); // In Node.js, we use the injected LocalStorage module,
      // in the browser, we use the browser's localStorage

      var storage = LocalStorage ? new LocalStorage(directory) : localStorage;
      return new Keystore(storage);
    }
  };
};